<template>
  <div>
    <div class="loading-state-container" v-if="loadScheduleTemplateState.isLoading">
      <div class="container">
        <PreloaderSection />
      </div>
    </div>
    <div v-if="!loadScheduleTemplateState.isLoading">
      <router-view
        v-if="!loadScheduleTemplateState.error"
        :scheduleTemplateData="scheduleTemplate" />
      <ErrorMessageScheduleTemplateContainer
        v-if="loadScheduleTemplateState.error"
        :error="loadScheduleTemplateState.error"
        :redirectLink="'/schedule-template'" />
    </div>
  </div>
</template>

<script>
import PreloaderSection from '@/components/PreloaderSection.vue';

import { loadScheduleTemplateById } from './api';
import ErrorMessageScheduleTemplateContainer from './ErrorMessageScheduleTemplateContainer.vue';

export default {
  components: {
    PreloaderSection,
    ErrorMessageScheduleTemplateContainer,
  },
  data() {
    return {
      scheduleTemplate: {
        name: null,
      },
      loadScheduleTemplateState: {
        isLoading: false,
        error: null,
      },
    };
  },
  created() {
    this.load(this.scheduleTemplateId);
  },
  computed: {
    scheduleTemplateId() {
      return this.$route.params.scheduleTemplateId;
    },
  },
  methods: {
    async load(scheduleTemplateId) {
      this.loadScheduleTemplateState.isLoading = true;
      try {
        const response = await loadScheduleTemplateById(scheduleTemplateId);
        this.scheduleTemplate = response.data;
        this.loadScheduleTemplateState.isLoading = false;
      } catch (error) {
        this.loadScheduleTemplateState.error = error.response;
        this.loadScheduleTemplateState.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';

.loading-state-container {
  margin-top: $spacer * 6;
}

</style>
